import styled from 'styled-components';
import { Spinner } from 'ui/spinner';
import { BasicFilterSelect } from 'ui/selects';
import { caption, colors, heading4, spacing, subtitle2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p304: pxToRem(304),
  p350: pxToRem(350),
};

export const PerformanceHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${colors.textPrimary};
  padding: ${spacing.threeQuarter} ${spacing.base};
`;

export const PerformanceHeaderMetricsSection = styled.div`
  ${heading4};
  display: flex;
  align-items: center;
  gap: ${spacing.base};
`;

export const PerformanceHeaderMetricsText = styled.span`
  ${subtitle2};
`;

export const PerformanceHeaderTitle = styled.div`
  ${heading4};
`;

export const WideBasicSelect = styled(BasicFilterSelect)`
  width: ${customSpacing.p350};
`;

export const PerformanceBodyWrapper = styled.div`
  padding: 0 ${spacing.base};
  width: 100%;
`;

export const ChartWrapper = styled.div`
  /* 
* We hide the default legends using this css selector.
* This style will not be applied on chart export.
* So, chart exports will get the default legends
* Since, our custom legend can't be exported. 
* */
  & .highcharts-legend {
    display: none;
  }
`;

export const PerformanceChartLegendWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -${spacing.plusHalf} 0 ${spacing.plusHalf} 0;
  gap: ${spacing.plusHalf};
`;

export const PerformanceChartLegendItem = styled.div`
  ${caption};
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
`;

export const PerformanceChartLegendText = styled.div`
  color: ${colors.textSecondary};
`;

export const EmptyTab = styled.div`
  margin: ${customSpacing.p304} auto ${spacing.x48};
`;

export const TabSpinner = styled(Spinner)`
  margin: ${customSpacing.p304} auto ${spacing.x48};
`;
